module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": _vm.totPLVal > 0 ? 'success' : _vm.totPLVal < 0 ? 'danger' : 'info'
    }
  }, [_vm._v("Profit Loss Details")])], 1), _vm._v(" "), (_vm.PL_AccordianButton) ? _c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "outline-info",
      "size": "xs"
    },
    on: {
      "click": function($event) {
        _vm.toggleActive()
      }
    }
  }, [_vm._v(_vm._s(_vm.PL_AccordianStatus ? "Hide Details" : "Show Details"))]) : _vm._e()], 1), _vm._v(" "), (_vm.PL_AccordianStatus) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": _vm.totPLVal > 0 ? 'success' : _vm.totPLVal < 0 ? 'danger' : 'info'
    }
  }, [_vm._v("Sales")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sm",
    attrs: {
      "id": "otherAdditionalTask"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.getInvoiceList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.buyerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vendorName))]), _vm._v(" "), _c('td', [(item.SlineUpload) ? _c('a', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/" + (_vm.PMS_jb_series.replaceAll('/', '_')) + "/" + (item.SlineUpload.replaceAll('/', '_'))))
        }
      }
    }, [_c('b-button', {
      staticClass: "mt-1",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "variant": "outline-info",
        "size": "xs"
      },
      on: {
        "click": function($event) {
          _vm.showExpenseDet(
            item,
            'Invoice',
            1,
            item.DocDtls_No,
            item.InvjobNo,
            'Inv'
          )
        }
      }
    }, [_vm._v(_vm._s(item.DocDtls_No))])], 1) : _c('a', [_c('b-button', {
      staticClass: "mt-1",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "variant": "outline-info",
        "size": "xs"
      },
      on: {
        "click": function($event) {
          _vm.showExpenseDet(
            item,
            'Invoice',
            1,
            item.DocDtls_No,
            item.InvjobNo,
            'Inv'
          )
        }
      }
    }, [_vm._v(_vm._s(item.DocDtls_No))])], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v("Inv Created : " + _vm._s(item.inv_create_date)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Inv Updated : " + _vm._s(item.inv_update_date))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.DocDtls_Typ))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Inv_Date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.AMT))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.GST))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.TotInvVal))])])
  }), _vm._v(" "), (_vm.getInvoiceList.length > 0) ? _c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.totInvVal))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.totInvGST))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.totInvGSTVal))])])]) : _vm._e(), _vm._v(" "), (_vm.getInvoiceList.length <= 0) ? _c('tr', [_vm._m(2)]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (_vm.PL_AccordianStatus) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": _vm.totPLVal > 0 ? 'success' : _vm.totPLVal < 0 ? 'danger' : 'info'
    }
  }, [_vm._v("Expense")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sm",
    attrs: {
      "id": "otherAdditionalTask"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [_vm._l((_vm.getExpenseList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.buyerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vendorName))]), _vm._v(" "), _c('td', [(item.SlineUpload) ? _c('a', {
      staticStyle: {
        "color": "blue"
      },
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/" + (_vm.PMS_jb_series.replaceAll('/', '_')) + "/" + (item.SlineUpload.replaceAll('/', '_'))))
        }
      }
    }, [_c('b-button', {
      staticClass: "mt-1",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "variant": "outline-info",
        "size": "xs"
      },
      on: {
        "click": function($event) {
          _vm.showExpenseDet(
            item,
            'Expense',
            2,
            item.docDtls_No,
            item.ExpjobNo,
            'Exp'
          )
        }
      }
    }, [_vm._v(_vm._s(item.docDtls_No))])], 1) : _c('a', [_c('b-button', {
      staticClass: "mt-1",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "variant": "outline-info",
        "size": "xs"
      },
      on: {
        "click": function($event) {
          _vm.showExpenseDet(
            item,
            'Expense',
            2,
            item.docDtls_No,
            item.ExpjobNo,
            'Exp'
          )
        }
      }
    }, [_vm._v(_vm._s(item.docDtls_No))])], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v("Exp Created : " + _vm._s(item.inv_create_date)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Exp Updated : " + _vm._s(item.inv_update_date))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.docDtls_Typ))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.Exp_Date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.AMT))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.GST))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.TotInvVal))])])
  }), _vm._v(" "), (_vm.getExpenseList.length > 0) ? _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.totExpVal))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.totExpGST))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.totExpGSTVal))])])]) : _vm._e(), _vm._v(" "), (_vm.getExpenseList.length <= 0) ? _c('tr', [_vm._m(5)]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm",
    attrs: {
      "id": "totalCalculation"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    style: (_vm.totPLValColor),
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Tot Inv : " + _vm._s(_vm.totInvVal))]), _vm._v(" "), _c('th', {
    style: (_vm.totPLValColor),
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("Tot Exp : " + _vm._s(_vm.totExpVal))]), _vm._v(" "), _c('th', {
    style: (_vm.totPLValColor),
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("\n              (Inv-Exp) : (" + _vm._s(_vm.totInvVal) + "-" + _vm._s(_vm.totExpVal) + ")\n            ")]), _vm._v(" "), _c('th', {
    style: (_vm.totPLValColor),
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("\n              Tot\n              " + _vm._s(_vm.totPLVal > 0 ? "Profit " : _vm.totPLVal < 0 ? "Loss " : "Profit Loss ") + " :\n              " + _vm._s(_vm.totPLVal) + "\n            ")]), _vm._v(" "), _c('th', {
    style: (_vm.totPLValColor),
    attrs: {
      "scope": "row"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.totPLVal > 0 ? "Profit " : _vm.totPLVal < 0 ? "Loss " : "Profit Loss ") + " %\n              : " + _vm._s(_vm.totPLPercentage + " %") + "\n            ")])])])])])]), _vm._v(" "), _c('b-modal', {
    ref: "otherTallyExpCharges-modal",
    attrs: {
      "id": "otherTallyExpCharges-modal",
      "title": _vm.modal_title + _vm.modal_JobNo,
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "tpt"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN.")]), _vm._v(" "), _c('th', [_vm._v("Particulars")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Barcode")]), _vm._v(" "), _c('th', [_vm._v("HSNCode")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("GST Rate")]), _vm._v(" "), _c('th', [_vm._v("IGST Amt")]), _vm._v(" "), _c('th', [_vm._v("CGST Amt")]), _vm._v(" "), _c('th', [_vm._v("SGST Amt")]), _vm._v(" "), _c('th', [_vm._v("Cest Rt/Amt")]), _vm._v(" "), _c('th', [_vm._v("Amt")]), _vm._v(" "), _c('th', [_vm._v("Total")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.ExpenseItemDeatils), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.prdDesc))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.qty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.barcde))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.hsnCd))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(item1.totAmt) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.gstRt))]), _vm._v(" "), _c('td', [_vm._v("\n                  " + _vm._s(item1.igstAmt) + "\n                ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.cgstAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.sgstAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.cesRt) + " / " + _vm._s(item1.cesAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.assAmt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.totItemVal) + " " + _vm._s(item1.orgCntry))])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('b', [_vm._v("Amount + Tax = Total Amount ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.singleItem.AMT) + " + " + _vm._s(_vm.taxAmount) + " =\n              " + _vm._s(_vm.singleItem.TotInvVal) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('center', [_c('b-button', {
    staticClass: "mt-1",
    staticStyle: {
      "font-size": "11px"
    },
    attrs: {
      "size": "sm",
      "variant": "danger"
    },
    on: {
      "click": _vm.hideExpenseDet
    }
  }, [_vm._v("\n              Close")])], 1)], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Buyer")]), _vm._v(" "), _c('th', [_vm._v("Vendor")]), _vm._v(" "), _c('th', [_vm._v("Inv No")]), _vm._v(" "), _c('th', [_vm._v("Inv Type")]), _vm._v(" "), _c('th', [_vm._v("Inv Date")]), _vm._v(" "), _c('th', [_vm._v("Inv AMT")]), _vm._v(" "), _c('th', [_vm._v("Inv GST AMT")]), _vm._v(" "), _c('th', [_vm._v("Total Inv")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "5"
    }
  }, [_c('b', [_vm._v("Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "red"
    },
    attrs: {
      "colspan": "6"
    }
  }, [_c('b', [_vm._v("NO Invoice Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Buyer")]), _vm._v(" "), _c('th', [_vm._v("Vendor")]), _vm._v(" "), _c('th', [_vm._v("Exp No")]), _vm._v(" "), _c('th', [_vm._v("Exp Type")]), _vm._v(" "), _c('th', [_vm._v("Exp Date")]), _vm._v(" "), _c('th', [_vm._v("Exp AMT")]), _vm._v(" "), _c('th', [_vm._v("Exp GST AMT")]), _vm._v(" "), _c('th', [_vm._v("Total Exp")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "5"
    }
  }, [_c('b', [_vm._v("Total")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "red"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_c('b', [_vm._v("NO Expense Document ADDED")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cfcaa01","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/profitLoss.vue
// module id = 2666
// module chunks = 0